import z from 'zod';

export const AiSummarySchema = z.object({
  summary: z.string(),
  recommendation: z.string(),
});
